// removed by extract-text-webpack-plugin
module.exports = {"itemCard":"_3K9kCXRAvDJWqmZfCt_WEM","courseCard":"_35hnWRvihICf-khuQRYXNV","cardLink":"_3nyhKGCn83us624tWWCwvK","ratingContainer":"_1S1sJfvsnO1y1CqxUcLYKG","cardFooter":"x7HVS1OnrIkd5_if8oiL8","courseItem":"_3d2pUcKiFARGL8OJlAidpE","uoc":"scF0K7A1nl0tWHQRm5jWY","GenEd":"XZDoRW0G3v3N9IkMUE51y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Program/ProgramCourseCard.css
// module id = 1324
// module chunks = 0